import { Pipe, PipeTransform } from '@angular/core';
import { Tag } from '../models/rich-data.model';

@Pipe({
  name: 'tagClasses'
})
export class TagClassesPipe implements PipeTransform {

  transform(tags: Tag[]): string {

    let classes = '';

    if (tags) {
      tags.forEach(tag => {
        classes += tag.name + ' ';
      });
    }

    return classes;
  }

}
